import { IdentityFooter, IdentityHeader } from "@speedycore/identity-ui";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getLegalAcceptance, requireLegalAcceptance } from "../lib/identityApi";

const PUBLIC_AUTH_ROUTES = [
  "/auth/login",
  "/auth/signup",
  "/auth/acceptance",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/verify-email",
  "/legal/terms",
  "/legal/privacy",
  "/legal/legal-update",
  "/legal/not-accepted",
  "/legal/",
];

export function AuthShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirectUri = params.get("redirect_uri");

  useEffect(() => {
    if (PUBLIC_AUTH_ROUTES.some((r) => location.pathname.startsWith(r))) return;
    let cancelled = false;
    void (async () => {
      try {
        const status = await getLegalAcceptance();
        if (cancelled) return;
        if (!status.accepted || status.needs_reaccept) {
          const target = redirectUri
            ? `/legal/legal-update?redirect_uri=${encodeURIComponent(redirectUri)}`
            : "/legal/legal-update";
          navigate(target, { replace: true });
          return;
        }
      } catch {
        try {
          const req = await requireLegalAcceptance();
          if (cancelled) return;
          if (req.required) {
            const target = redirectUri
              ? `/legal/not-accepted?redirect_uri=${encodeURIComponent(redirectUri)}`
              : "/legal/not-accepted";
            navigate(target, { replace: true });
          }
        } catch {
          /* ignore */
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.pathname, redirectUri, navigate]);

  return (
    <div className="sc-identity-root">
      <div className="sc-identity-layout" style={{ minHeight: "100vh" }}>
        <header className="sc-identity-top">
          <IdentityHeader />
        </header>
        <main className="sc-identity-main">
          <Outlet />
        </main>
        <IdentityFooter />
      </div>
    </div>
  );
}
